import { AbstractReportPmsApiService } from '../abstract-report.service';
import { FrontDeskDepartureReport } from '../../../models/reports/front-desk/departure-report.model';

/**
 * @class FrontDeskDepartureReportPmsApiService
 * @extends {AbstractReportPmsApiService<FrontDeskDepartureReport>}
 */
export class FrontDeskDepartureReportPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/front-desk/departure';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {FrontDeskDepartureReport}
     * @protected
     */
    newModel(attributes, ...params) {

        return new FrontDeskDepartureReport(attributes);
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/front-desk/departure-report.service.js